import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaEdit, 
    FaArrowLeft,
    FaSort
} from 'react-icons/fa';

const EngineerSocietyWorkList = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    // Dummy data matching the image
    const [data] = useState([
        { id: 1, name: "धारेश्वर मजूर सहकारी संस्था", phone: "९५७९३४९९८२" },
        { id: 2, name: "श्री हनुमान मजूर सहकारी संस्था मर्यादीत", phone: "७३८७८३५०५०" },
        { id: 3, name: "रोहिडेश्वर मजूर सहकारी संस्था लि", phone: "९८२२०४५७२९" },
        { id: 4, name: "यशवंतराय मजूर सहकारी संस्था", phone: "९०१९०१७८८२" },
        { id: 5, name: "श्री गणेश मजूर सहकारी संस्था", phone: "७७०९७१४१३७" },
        { id: 6, name: "सार्थ मजूर सहकारी संस्था सोनगाव", phone: "७८८७८७७७०७" },
        { id: 7, name: "यशोदा मजूर सहकारी संस्था कालाखैरेवाडी", phone: "९८८११५१२२२" }
    ]);

    const filteredData = data.filter(item => 
        item.name.includes(searchTerm) || 
        item.phone.includes(searchTerm)
    );

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-marathi">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-8 px-2">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate('/engineer/work-passbook-menu')}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={16} />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800 tracking-tight">मजूर संस्था कामाची यादी</h1>
                    </div>
                    <div className="text-xs font-medium text-gray-400">
                        पुणे जिल्हा परिषद / <span className="text-gray-500 font-bold">मजूर संस्था कामाची यादी</span>
                    </div>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 mb-8">
                    {/* Toolbar */}
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8">
                        <div className="flex rounded overflow-hidden">
                            <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 text-xs font-bold transition">कॉपी करा</button>
                            <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 text-xs font-bold border-l border-gray-500 transition">एक्सेल</button>
                            <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 text-xs font-bold border-l border-gray-500 transition">प्रिंट</button>
                        </div>
                        <div className="flex items-center gap-3">
                            <label className="text-sm font-bold text-gray-600">शोध:</label>
                            <input 
                                type="text" 
                                className="border border-gray-200 rounded px-3 py-1.5 text-sm outline-none focus:border-blue-500 transition-all font-medium bg-gray-50/30 w-64"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="border border-gray-100 rounded-lg overflow-hidden">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="border-b border-gray-200 bg-white">
                                    <th className="px-6 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 group cursor-pointer hover:bg-gray-50 uppercase w-24">
                                        <div className="flex items-center justify-between font-marathi">क्र. <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                    </th>
                                    <th className="px-6 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 group cursor-pointer hover:bg-gray-50">
                                        <div className="flex items-center justify-between font-marathi">मजूर संस्था <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                    </th>
                                    <th className="px-6 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 group cursor-pointer hover:bg-gray-50">
                                        <div className="flex items-center justify-between font-marathi">फोन क्र. <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                    </th>
                                    <th className="px-6 py-4 text-[13px] font-black text-gray-800 text-center group cursor-pointer hover:bg-gray-50 w-32">
                                        <div className="flex items-center justify-center font-marathi">कृती <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={index} className="hover:bg-blue-50/20 group transition-colors border-b border-gray-50 last:border-0 text-[14px] text-gray-600 font-bold">
                                        <td className="px-6 py-4 border-r border-gray-100">{item.id}</td>
                                        <td className="px-6 py-4 border-r border-gray-100 text-gray-900">{item.name}</td>
                                        <td className="px-6 py-4 border-r border-gray-100">{item.phone}</td>
                                        <td className="px-6 py-4 text-center">
                                            <button 
                                                onClick={() => navigate(`/engineer/society-work-detail/${item.id}`)}
                                                className="text-blue-500 hover:text-blue-700 transition transform active:scale-95"
                                            >
                                                <FaEdit size={16} />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Footer */}
                    <div className="flex justify-between items-center mt-6 text-sm font-bold text-gray-500">
                        <div>
                            {filteredData.length} पैकी १ ते {filteredData.length} नोंदी दाखवत आहे
                        </div>
                        <div className="flex items-center gap-1">
                            <button className="px-4 py-2 border border-gray-200 rounded text-gray-400 hover:bg-gray-50 transition cursor-not-allowed">मागील</button>
                            <button className="px-4 py-2 bg-blue-600 text-white rounded shadow-sm shadow-blue-200">१</button>
                            <button className="px-4 py-2 border border-gray-200 rounded text-gray-400 hover:bg-gray-50 transition cursor-not-allowed">पुढे</button>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerSocietyWorkList;
